import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Dropdown from "bootstrap/js/dist/dropdown";

const Navbar = () => {
  const navigate = useNavigate();
  const userName = window.sessionStorage.getItem("userName");

  useEffect(() => {
    // Initialize all dropdowns manually
    const dropdownTriggerList = [].slice.call(
      document.querySelectorAll(".dropdown-toggle"),
    );
    dropdownTriggerList.map(
      (dropdownToggleEl) => new Dropdown(dropdownToggleEl),
    );
  }, []);

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container-fluid">
        <a className="navbar-brand" href="#">
          BossInvestor
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link className="nav-link" to="/exploreDataManager">
                Explore
              </Link>
            </li>

            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="strategyDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Strategy Manager
              </a>
              <ul className="dropdown-menu" aria-labelledby="strategyDropdown">
                <li>
                  <Link className="dropdown-item" to="/liveStrategies">
                    Strategy Details
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    to="/strategyDescriptionTable"
                  >
                    Strategy Description Code
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/stockSplitCalender">
                    Stock Split Calendar
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    to="/strategyRebalanceManager"
                  >
                    Strategy Rebalanced
                  </Link>
                </li>
              </ul>
            </li>

            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="notificationDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Notification Manager
              </a>
              <ul
                className="dropdown-menu"
                aria-labelledby="notificationDropdown"
              >
                <li>
                  <Link
                    className="dropdown-item"
                    to="/notificationDataManager/email"
                  >
                    Email Notification
                  </Link>
                </li>
                {/* <li><Link className="dropdown-item" to="/notificationDataManager/whatsapp">WhatsApp Notification</Link></li> */}
                <li>
                  <Link
                    className="dropdown-item"
                    to="/notificationDataManager/app"
                  >
                    App Notification
                  </Link>
                </li>
              </ul>
            </li>

            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="adminDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Admin Operation
              </a>
              <ul className="dropdown-menu" aria-labelledby="adminDropdown">
                <li>
                  <Link className="dropdown-item" to="/refreshCache">
                    Refresh
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/scheduleJobStatus">
                    Scheduler Job Status
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/auditLogs">
                    Audit Logs
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/adHocQuarterlyAndYearly">
                    Individual Quarterly and Yearly 
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/sourceTechnicalData">
                    Source Technical Data
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/sourceReportDetails">
                    Source Fundamental/Technical Details
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    to="/ad-hoc-individualSourcing"
                  >
                    Ad-Hoc individual sourcing
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/SourceDailyWeeklyData">
                    Data Sourcing Status Report
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/databaseViewReport">
                    Data Source Status UAT vs PROD
                  </Link>
                </li>
              </ul>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/newsletterManager">
                Blogs
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/discountsCoupons">
                Discounts & Coupons
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/strategies">
                Strategies
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/stocks">
                Stocks
              </Link>
            </li>
          </ul>

          <ul className="navbar-nav ms-auto align-items-center">
            <li className="nav-item">
              <span className="nav-link">{userName}</span>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-danger btn-sm ms-2"
                onClick={() => {
                  sessionStorage.clear();
                  navigate("/logout");
                }}
              >
                Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
